var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 38,
  viewBox: "0 0 47 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.9502 4.61035C39.858 3.68009 41.3247 3.68009 42.2324 4.61035C43.1402 5.54077 43.1402 7.04419 42.2324 7.97461L17.6055 33.2148C16.6977 34.1453 15.231 34.1453 14.3232 33.2148L4.59375 23.2432C3.68597 22.3128 3.686 20.8093 4.59375 19.8789C5.50151 18.9485 6.96818 18.9486 7.87598 19.8789L15.9531 28.1572L38.9502 4.61035Z"
})));
export default SvgCheck;